<div class="td-wb-w8ben-form-special-tax-benefits">
  <div class="td-wb-w8ben-form-special-tax-benefits__content">
    <div class="td-wb-w8ben-form-special-tax-benefits__header">
      <span [attr.id]="getModalId()"
            translate="tdWb.w8BenForm.modal.specialTaxBenefits.TITLE"></span>
    </div>
    <td-wb-notification class="td-wb-w8ben-form-special-tax-benefits__notification"
                        notificationType="info">
      <span [innerHTML]="'tdWb.w8BenForm.modal.specialTaxBenefits.NOTIFICATION' | translate"></span>
    </td-wb-notification>
    <div class="td-wb-w8ben-form-special-tax-benefits__link">
      <a id="td-wb-w8ben-form-special-tax-benefits-download-link"
         tdWbHref="link_w8ben_form_pdf"
         [tdWbHrefTaggingEvent]="'w8ben:taxbenefit:download:flow ' + flow"
         target="blank">
        <td-wb-icon iconId="download--small"
                    size="14" />
        <span translate="tdWb.w8BenForm.modal.specialTaxBenefits.LINK_TEXT"></span>
      </a>
    </div>
    <div class="td-wb-w8ben-form-special-tax-benefits__actions">
      <td-wb-divider class="td-wb-w8ben-form-special-tax-benefits__divider" />
      <td-wb-page-action-panel position="end"
                               [top]="true"
                               [bottom]="false"
                               [left]="false"
                               [right]="false">
        <button id="td-wb-w8ben-form-special-tax-benefits-back"
                tdWbButton
                tdWbButtonType="secondary"
                (click)="onBackClick()">
          <span translate="tdWb.w8BenForm.modal.specialTaxBenefits.BACK"></span>
        </button>
        <button id="td-wb-w8ben-form-tax-special-benefits-exit"
                tdWbButton
                tdWbButtonType="primary"
                [tdWbModalClose]="modalCloseReason">
          <span translate="tdWb.w8BenForm.modal.specialTaxBenefits.EXIT"></span>
        </button>
      </td-wb-page-action-panel>
    </div>
  </div>
</div>
